export default "__VITE_ASSET__ppQJh5CY__"